<div class="container">
  <div class="form-container">
    <h3>Set password</h3>

    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (mode === 'form') {
      <form [formGroup]="form">

        <div class="pb-12 pt-12">
          <div class="custom-icon-input-container">
            <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="password" placeholder="New Password *" autocomplete="off">
            <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
          </div>
          @if (form.controls.password.touched) {
            <div class="alert">

              @if (form.controls.password.hasError('minlength')) {
                <div class="form-validation-error">
                  Password should be at least 6 symbols long
                </div>
              }
              @if (form.controls.password.hasError('pattern')) {
                <div class="form-validation-error">
                  Password must contain at least one uppercase letter, one lowercase letter, one number and one special character
                </div>
              }
            </div>
          }
        </div>

        <div class="pb-12">
          <div class="custom-icon-input-container">
            <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="passwordConfirm" placeholder="Password confirm *" autocomplete="off">
            <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
          </div>
          @if (form.controls.passwordConfirm.touched) {
            <div class="alert">

              @if (form.hasError('passwordMismatch')) {
                <div class="form-validation-error">
                  Passwords should mach
                </div>
              }
            </div>
          }
        </div>

        <button matButton="filled" class="button-regular w-100 pb-12" [disabled]="form.invalid || isLoading" (click)="send()">Change</button>

      </form>
    } @else {
      {{message}}
    }


</div>

</div>


